import type { State, Actions } from './types'
import { START_FETCH, FETCHED } from './actionTypes'
import schema from './schema'

const initialState = {
  needsFetched: true,
  header: { brandLinks: [], desktopLinks: [], mobileLinks: [] },
  footer: {
    mainLinks: [],
    brandLinks: [],
    socialLinks: [],
    contactLinks: [],
    legalLinks: [],
  },
}

export default function (
  state = initialState as State,
  action: Actions,
): State {
  switch (action.type) {
    case START_FETCH:
      return {
        ...state,
        needsFetched: false,
      }
    case FETCHED: {
      const results = schema(action.payload)
      return {
        ...state,
        ...results,
      }
    }
    default:
      return state
  }
}
